import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { MENU_LIST } from "../constants";

import styles from "./dropdown.style.module.css";

export const Dropdown = ({ navBgColor, navHeight }) => {
  const navigate = useNavigate();
  const [dropdownHeight, setDropdownHeight] = useState(0);

  const handleMouseEnter = (e) => {
    const dropdownContainer = e.currentTarget.querySelector(
      `.${styles.dropdownContainer}`
    );
    if (dropdownContainer) {
      const fullHeight = dropdownContainer.scrollHeight;
      setDropdownHeight(fullHeight);
    }
  };

  const handleMouseLeave = () => {
    setDropdownHeight(0);
  };

  return (
    <div className={styles.menuContainer}>
      {MENU_LIST.map((menu) => {
        return (
          <div
            className={styles.dropdownMenu}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{
              "--dropdownHeight": `${dropdownHeight}px`,
            }}
          >
            <div
              className={styles.menuItem}
              onClick={() => !menu?.dropdown && navigate(menu.path)}
            >
              {menu.name}
            </div>

            {/* dropdwon */}
            {menu?.dropdown && (
              <div className={styles.dropdownContainer}>
                {menu.dropdown.map((dropdown) => {
                  return (
                    <div
                      className={styles.menuItem}
                      onClick={() => {
                        navigate(dropdown.path);
                      }}
                    >
                      {dropdown.name}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
